import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { TogglePanel } from 'web-ui-components/lib/molecules/panels';
import { InformationRevealPanel } from 'web-ui-components/lib/layout/content';
import { Title } from 'web-ui-components/lib/atoms/text';
import { Field, FieldBody, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { Prefix, Input } from 'web-ui-components/lib/atoms/forms';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import SweepAccountCard from '../SweepAccountCard';

// eslint-disable-next-line complexity
const SweepCard = ({
  toggleOptionFactory,
  isEnabled,
  handleSweepCheck,
  targetAmount,
  handleTargetAmountChange,
  savingAccountsAvailable,
  thresholdAmount,
  handleThresholdAmountChange,
  isButtonDisabled,
  cancelSweepChange,
  isLoading,
  confirmSweepChange,
  content,
  showThresholdMsg,
  showTargetMsg,
  handleSweepAccountCardClick,
  showSweepAccountSelector,
  handleSelectSweepAccount,
  savingsAccountID,
  handleTargetOnBlur,
  handleThresholdOnBlur,
}) => {
  const {
    sweepToAccountText,
    sweepFromAccountText,
    amountDeductFrom,
    poundSign,
    cancelText,
    confirmText,
    thresholdValidationMsg,
    targetValidationMsg,
    sweepsInfoText,
    sweepRevealTitleText,
    sweepInfoText,
  } = content;
  return (
    <Card bordered="unbranded">
      <TogglePanel
        toggleOptionFactory={toggleOptionFactory}
        active={isEnabled}
        onChange={handleSweepCheck}
      >
        <br />
        <StandardBody>
          <p>{sweepInfoText}</p>
        </StandardBody>
        <InformationRevealPanel
          title={''}
          titleText={sweepRevealTitleText}
          data-test-id="sweepsInformationReveal"
        >
          <StandardBody isFlush>
            <span>{sweepsInfoText}</span>
          </StandardBody>
        </InformationRevealPanel>
        <Title size="h5">{sweepToAccountText}</Title>
        <Field>
          <FieldBody>
            <Prefix>{poundSign}</Prefix>
            <Input
              type="text"
              value={thresholdAmount}
              onChange={handleThresholdAmountChange}
              onBlur={handleThresholdOnBlur}
              hasPrefix
            />
          </FieldBody>
        </Field>
        {showThresholdMsg && (
          <ValidationMessage value={thresholdValidationMsg} iconType="ExclamationCircleLarge" />
        )}
        <Title size="h5">{sweepFromAccountText}</Title>
        <SweepAccountCard
          accountData={savingAccountsAvailable}
          savingsAccountID={savingsAccountID}
          showSweepAccountSelector={showSweepAccountSelector}
          handleSweepAccountCardClick={handleSweepAccountCardClick}
          handleSelectSweepAccount={handleSelectSweepAccount}
          content={content}
        />
        <Title size="h5" className="u-padding-top-1">
          {amountDeductFrom}
        </Title>
        <Field>
          <FieldBody>
            <Prefix>{poundSign}</Prefix>
            <Input
              type="text"
              value={targetAmount}
              onChange={handleTargetAmountChange}
              onBlur={handleTargetOnBlur}
              hasPrefix
            />
          </FieldBody>
        </Field>
        {showTargetMsg && (
          <ValidationMessage value={targetValidationMsg} iconType="ExclamationCircleLarge" />
        )}
        {isButtonDisabled && !showTargetMsg && !showThresholdMsg && savingsAccountID && (
          <ButtonGroup>
            <Button className="u-margin-right-2" display="secondary" onClick={cancelSweepChange}>
              {cancelText}
            </Button>
            <Button display="primary" isLoading={isLoading} onClick={confirmSweepChange}>
              {confirmText}
            </Button>
          </ButtonGroup>
        )}
      </TogglePanel>
      {isEnabled && (
        <StandardBody>
          <p>{content.sweepsPageFooter}</p>
        </StandardBody>
      )}
    </Card>
  );
};
SweepCard.propTypes = {
  content: PropTypes.shape({
    amountDeductFrom: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    poundSign: PropTypes.string,
    sweepFromAccountText: PropTypes.string,
    sweepsPageFooter: PropTypes.string,
    sweepToAccountText: PropTypes.string,
    targetValidationMsg: PropTypes.string,
    thresholdValidationMsg: PropTypes.string,
    sweepsInfoText: PropTypes.string,
    sweepInfoText: PropTypes.string,
    sweepRevealTitleText: PropTypes.string,
  }),
  toggleOptionFactory: PropTypes.func,
  isEnabled: PropTypes.bool,
  handleSweepCheck: PropTypes.func,
  targetAmount: PropTypes.string,
  handleTargetAmountChange: PropTypes.func,
  savingAccountsAvailable: PropTypes.array,
  thresholdAmount: PropTypes.string,
  handleThresholdAmountChange: PropTypes.func,
  isButtonDisabled: PropTypes.bool,
  cancelSweepChange: PropTypes.func,
  isLoading: PropTypes.bool,
  confirmSweepChange: PropTypes.func,
  showThresholdMsg: PropTypes.bool,
  showTargetMsg: PropTypes.bool,
  handleSweepAccountCardClick: PropTypes.func,
  showSweepAccountSelector: PropTypes.bool,
  handleSelectSweepAccount: PropTypes.func,
  savingsAccountID: PropTypes.string,
  handleTargetOnBlur: PropTypes.func,
  handleThresholdOnBlur: PropTypes.func,
};
export default SweepCard;
